// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* === Dark Mode Overrides === */
body[data-theme=dark] {
  background-color: #121212 !important;
  color: #f8f9fa !important;
}

/* Navbar */
body[data-theme=dark] .navbar-top,
body[data-theme=dark] .navbar {
  background-color: #1a1a1a;
  color: #f8f9fa;
}

/* Cards */
body[data-theme=dark] .card,
body[data-theme=dark] .card-body {
  background-color: #1f1f1f !important;
  color: #f8f9fa !important;
  border-color: #2a2a2a !important;
}

/* Dropdown menus */
.dropdown-item:hover span {
  color: black !important;
}

body[data-theme=dark] .dropdown-menu {
  background-color: #1f1f1f;
  color: #f8f9fa;
  border-color: #2a2a2a;
}

/* Tables */
body[data-theme=dark] table,
body[data-theme=dark] th {
  background-color: #1f1f1f !important;
  color: #f8f9fa !important;
  border-color: #2a2a2a !important;
}

body[data-theme=dark] td {
  background-color: #1f1f1f;
  color: #f8f9fa;
  border-color: #2a2a2a;
}

body[data-theme=dark] tr:not(.no-hover):hover td {
  background-color: #242a33 !important;
}

/* Forms & Inputs */
body[data-theme=dark] input,
body[data-theme=dark] textarea,
body[data-theme=dark] select,
body[data-theme=dark] .form-control,
body[data-theme=dark] .custom-file-label,
body[data-theme=dark] .input-group-merge {
  background-color: #2a2a2a;
  color: #f8f9fa;
  border-color: #3a3a3a;
}

body[data-theme=dark] input::placeholder,
body[data-theme=dark] textarea::placeholder {
  color: #b0b0b0 !important;
}

/* Buttons */
body[data-theme=dark] .btn {
  color: #f8f9fa !important;
}

body[data-theme=dark] .btn.btn-white {
  background-color: #2a2a2a !important;
  border-color: #3a3a3a !important;
  color: #f8f9fa !important;
}

/* Links and text */
body[data-theme=dark] a,
body[data-theme=dark] span:not(.badge),
body[data-theme=dark] p,
body[data-theme=dark] h1,
body[data-theme=dark] h2,
body[data-theme=dark] h3,
body[data-theme=dark] h4,
body[data-theme=dark] h5,
body[data-theme=dark] h6 {
  color: #f8f9fa;
}

body[data-theme=dark] ::-webkit-scrollbar {
  width: 8px;
}

body[data-theme=dark] ::-webkit-scrollbar-thumb {
  background-color: #2a2a2a;
  border-radius: 4px;
}

body[data-theme=dark] ::-webkit-scrollbar-track {
  background-color: #121212;
}

body,
.card,
.navbar-top,
.dropdown-menu,
.table,
.form-control,
.modal-theme {
  transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease;
}

body[data-theme=dark] .tenant-badge {
  background-color: #cdd3d6 !important;
  color: #020617 !important;
}

body:not([data-theme=dark]) .tenant-badge {
  background-color: #cdd3d6;
  color: #020617;
}

body[data-theme=dark] tr.selected-row td {
  background-color: #088717 !important;
  color: #ffffff;
}

body[data-theme=dark] tr.selected-row:hover td {
  background-color: #088717 !important;
}

/* Normal pagination text (non-active) */
body[data-theme=dark] .pagination .page-item:not(.active) .page-link {
  color: #8898aa;
  /* Bootstrap blue */
}

body[data-theme=dark] .pagination .page-item.disabled .page-link {
  color: #6b7280;
  border-color: rgba(90, 89, 89, 0.623);
  background-color: transparent;
  opacity: 1;
  cursor: not-allowed;
}

body[data-theme=dark] table tbody td.selection-cell {
  background-color: #222325;
  border-right: 1px solid #3a3f48;
}

body[data-theme=dark] table thead th.selection-cell {
  background-color: #323238;
  border-right: 1px solid #3a3f48;
}

body[data-theme=dark] table tbody tr:not(.no-hover):hover td.selection-cell {
  background-color: #323641 !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/custom/_darkmode.scss"],"names":[],"mappings":"AAAA,gCAAA;AACA;EACE,oCAAA;EACA,yBAAA;AACF;;AAEA,WAAA;AACA;;EAEE,yBAAA;EACA,cAAA;AACF;;AAEA,UAAA;AACA;;EAEE,oCAAA;EACA,yBAAA;EACA,gCAAA;AACF;;AAEA,mBAAA;AACA;EACE,uBAAA;AACF;;AAEA;EACE,yBAAA;EACA,cAAA;EACA,qBAAA;AACF;;AAEA,WAAA;AACA;;EAEE,oCAAA;EACA,yBAAA;EACA,gCAAA;AACF;;AAGA;EACE,yBAAA;EACA,cAAA;EACA,qBAAA;AAAF;;AAGA;EACE,oCAAA;AAAF;;AAGA,mBAAA;AACA;;;;;;EAME,yBAAA;EACA,cAAA;EACA,qBAAA;AAAF;;AAGA;;EAEE,yBAAA;AAAF;;AAGA,YAAA;AACA;EACE,yBAAA;AAAF;;AAGA;EACE,oCAAA;EACA,gCAAA;EACA,yBAAA;AAAF;;AAGA,mBAAA;AACA;;;;;;;;;EASE,cAAA;AAAF;;AAGA;EACE,UAAA;AAAF;;AAGA;EACE,yBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,yBAAA;AAAF;;AAGA;;;;;;;EAOE,+EAAA;AAAF;;AAGA;EACE,oCAAA;EACA,yBAAA;AAAF;;AAGA;EACE,yBAAA;EACA,cAAA;AAAF;;AAGA;EACE,oCAAA;EACA,cAAA;AAAF;;AAGA;EACE,oCAAA;AAAF;;AAGA,wCAAA;AACA;EACE,cAAA;EACA,mBAAA;AAAF;;AAGA;EACE,cAAA;EACA,qCAAA;EACA,6BAAA;EACA,UAAA;EACA,mBAAA;AAAF;;AAGA;EACE,yBAAA;EACA,+BAAA;AAAF;;AAGA;EACE,yBAAA;EACA,+BAAA;AAAF;;AAGA;EACE,oCAAA;AAAF","sourcesContent":["/* === Dark Mode Overrides === */\r\nbody[data-theme=\"dark\"] {\r\n  background-color: #121212 !important;\r\n  color: #f8f9fa !important;\r\n}\r\n\r\n/* Navbar */\r\nbody[data-theme=\"dark\"] .navbar-top,\r\nbody[data-theme=\"dark\"] .navbar {\r\n  background-color: #1a1a1a;\r\n  color: #f8f9fa;\r\n}\r\n\r\n/* Cards */\r\nbody[data-theme=\"dark\"] .card,\r\nbody[data-theme=\"dark\"] .card-body {\r\n  background-color: #1f1f1f !important;\r\n  color: #f8f9fa !important;\r\n  border-color: #2a2a2a !important;\r\n}\r\n\r\n/* Dropdown menus */\r\n.dropdown-item:hover span {\r\n  color: black !important;\r\n}\r\n\r\nbody[data-theme=\"dark\"] .dropdown-menu {\r\n  background-color: #1f1f1f;\r\n  color: #f8f9fa;\r\n  border-color: #2a2a2a;\r\n}\r\n\r\n/* Tables */\r\nbody[data-theme=\"dark\"] table,\r\nbody[data-theme=\"dark\"] th {\r\n  background-color: #1f1f1f !important;\r\n  color: #f8f9fa !important;\r\n  border-color: #2a2a2a !important;\r\n}\r\n\r\n\r\nbody[data-theme=\"dark\"] td {\r\n  background-color: #1f1f1f;\r\n  color: #f8f9fa;\r\n  border-color: #2a2a2a;\r\n}\r\n\r\nbody[data-theme=\"dark\"] tr:not(.no-hover):hover td {\r\n  background-color: #242a33 !important;\r\n}\r\n\r\n/* Forms & Inputs */\r\nbody[data-theme=\"dark\"] input,\r\nbody[data-theme=\"dark\"] textarea,\r\nbody[data-theme=\"dark\"] select,\r\nbody[data-theme=\"dark\"] .form-control,\r\nbody[data-theme=\"dark\"] .custom-file-label,\r\nbody[data-theme=\"dark\"] .input-group-merge {\r\n  background-color: #2a2a2a;\r\n  color: #f8f9fa;\r\n  border-color: #3a3a3a;\r\n}\r\n\r\nbody[data-theme=\"dark\"] input::placeholder,\r\nbody[data-theme=\"dark\"] textarea::placeholder {\r\n  color: #b0b0b0 !important;\r\n}\r\n\r\n/* Buttons */\r\nbody[data-theme=\"dark\"] .btn {\r\n  color: #f8f9fa !important;\r\n}\r\n\r\nbody[data-theme=\"dark\"] .btn.btn-white {\r\n  background-color: #2a2a2a !important;\r\n  border-color: #3a3a3a !important;\r\n  color: #f8f9fa !important;\r\n}\r\n\r\n/* Links and text */\r\nbody[data-theme=\"dark\"] a,\r\nbody[data-theme=\"dark\"] span:not(.badge),\r\nbody[data-theme=\"dark\"] p,\r\nbody[data-theme=\"dark\"] h1,\r\nbody[data-theme=\"dark\"] h2,\r\nbody[data-theme=\"dark\"] h3,\r\nbody[data-theme=\"dark\"] h4,\r\nbody[data-theme=\"dark\"] h5,\r\nbody[data-theme=\"dark\"] h6 {\r\n  color: #f8f9fa;\r\n}\r\n\r\nbody[data-theme=\"dark\"] ::-webkit-scrollbar {\r\n  width: 8px;\r\n}\r\n\r\nbody[data-theme=\"dark\"] ::-webkit-scrollbar-thumb {\r\n  background-color: #2a2a2a;\r\n  border-radius: 4px;\r\n}\r\n\r\nbody[data-theme=\"dark\"] ::-webkit-scrollbar-track {\r\n  background-color: #121212;\r\n}\r\n\r\nbody,\r\n.card,\r\n.navbar-top,\r\n.dropdown-menu,\r\n.table,\r\n.form-control,\r\n.modal-theme {\r\n  transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease;\r\n}\r\n\r\nbody[data-theme=\"dark\"] .tenant-badge {\r\n  background-color: #cdd3d6 !important;\r\n  color: #020617 !important;\r\n}\r\n\r\nbody:not([data-theme=\"dark\"]) .tenant-badge {\r\n  background-color: #cdd3d6;\r\n  color: #020617;\r\n}\r\n\r\nbody[data-theme=dark] tr.selected-row td {\r\n  background-color: #088717 !important;\r\n  color: #ffffff;\r\n}\r\n\r\nbody[data-theme=dark] tr.selected-row:hover td {\r\n  background-color: #088717 !important;\r\n}\r\n\r\n/* Normal pagination text (non-active) */\r\nbody[data-theme=\"dark\"] .pagination .page-item:not(.active) .page-link {\r\n  color: #8898aa;\r\n  /* Bootstrap blue */\r\n}\r\n\r\nbody[data-theme=\"dark\"] .pagination .page-item.disabled .page-link {\r\n  color: #6b7280;\r\n  border-color: rgba(90, 89, 89, 0.623);\r\n  background-color: transparent;\r\n  opacity: 1;\r\n  cursor: not-allowed;\r\n}\r\n\r\nbody[data-theme=\"dark\"] table tbody td.selection-cell {\r\n  background-color: #222325;\r\n  border-right: 1px solid #3a3f48;\r\n}\r\n\r\nbody[data-theme=\"dark\"] table thead th.selection-cell {\r\n  background-color: #323238;\r\n  border-right: 1px solid #3a3f48;\r\n}\r\n\r\nbody[data-theme=\"dark\"] table tbody tr:not(.no-hover):hover td.selection-cell {\r\n  background-color: #323641 !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
